export default {
    title_list: 'Artifcts',
    title_page: 'Artifct',
    title_create_page: 'Create Artifct',
    title_edit_page: 'Change Artifct',

    labels: {
        images: 'Images',
        documents: 'Documentation',
        drag_in_drop: 'Drag or click to select files',
        file_error: 'File {f} does not meet limits',
        document: 'Document',
        document_type: 'Document type',
        in_the_future: 'In the future',
    },

    filter: {
        labels: {
            title: 'Title',
            user_id: 'User',
            country_id: 'Country',
            is_published: 'Public',
            is_inspiration: 'Inspiration',

            is_old_is_it: 'Is set - How old is it? (previous version)',
            is_origin_year: 'Is set - How old is it? (new version)',
            is_main: 'Displayed on the homepage',
        }
    },

    table: {
        labels: {
            id: 'ID',
            image: 'Picture',
            title: 'Title',
            user_id: 'User',
            is_published: 'Public',
            is_inspiration: 'Inspiration',
            country_id: 'Country',
            is_main: 'On homepage',
        }
    },

    buttons: {

    },

    form: {
        types: 'Types',
        tags: 'Tags',
        user_id: 'User',
        countries: 'Country',
        occasion_id: 'Occasion',
        title: 'Title',
        value_id: 'Value',
        when_acquired: 'When acquired',
        market: 'Market',
        old_is_it: 'How old is it? (previous version)',
        origin_type_id: 'How old is it? (type)',
        origin_year: 'How old is it? (year)',
        origin_century_id: 'How old is it? (century)',
        artist: 'Artist',
        height: 'Height',
        width: 'Width',
        depth: 'Depth',
        current_location: 'Current location',
        body: 'Description',
        is_published: 'Public',
        is_inspiration: 'Inspiration',
        visible: 'Displayed by Membership terms',
        is_main: 'Displayed on the homepage',
        is_main_position: 'Display order on the homepage',
        size_unit_id: 'Size unit',
        weight: 'Weight',
        weight_unit_id: 'Weight unit',
    },
}
